import { gql } from '@apollo/client';

export const GET_CSVFILE_ROWS = gql`
  query GetCSVFileRows($input: CSVFileRowsInput!) {
    csvFileRows: getCSVFileRows(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          values
        }
        cursor
      }
    }
  }
`;
